export const sessionLocalStore = window.localStorage
